import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.home-hero__slider');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'fade',
      perMove: 1,
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: true,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        640: {
          pagination: false,
        },
      },
    });
    splide.mount({ AdjustableHeight });
  }
});
